<template>
  <div class="container max-w-full mx-auto md:py-4 px-6 text-gray-800">
    <div class="max-w-xl mx-auto">
      <div class="relative">
        <div class="flex flex-wrap">
          <div class="mt-6">
            <h1 class="text-4xl mb-1 font-bold">Recuperar Senha</h1>
          </div>
        </div>
        <form action class="mt-6" @submit.prevent="doRecover">
          <input-icon
            :icon="{ name: 'envelope', type: 'regular' }"
            id="user"
            name="user"
            v-model="email"
            type="text"
            label="E-mail:"
          ></input-icon>
          <div class="flex flex-col ">
            <button-icon
              text="Recuperar minha senha"
              type="submit"
              icon="right-arrow-alt"
              class="lg:flex-1 bg-primary hover:bg-indigo-400 mb-1 mt-7"
            ></button-icon>
            <div class="align-middle mt-6 ">
              <box-icon name='arrow-back' class="fill-current p-1"></box-icon>
              <router-link to="/auth/login" class="align-middle">
                Voltar para tela de login
              </router-link>
            </div>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data () {
    return {
      email: null
    }
  },
  methods: {
    doRecover () {
      this.$store.dispatch('RECOVER_PASSWORD', {
        email: this.email
      }).then((response) => {
        this.$toasted.success('E-mail com as instruções de recuperação enviado!', {
          position: 'top-center',
          duration: 5000,
          icon: 'check'
        })
        this.$router.push({ name: 'login' })
      })
    }
  }
}
</script>

<style>

</style>
